import React from 'react';
import './SocialCard.css';
import '../styles.css'

const SocialCard = ({ name, link, previewImage, username }) => {
  const className = name.toLowerCase(); // Ej: 'facebook'

  return (
    <div className="social-card">
      <img src={previewImage} alt={`Preview de ${name}`} className="preview-img" />
      <div className="card-content">
        <h3 className={`social-title ${className}`}>
          <span className={`icon`}>
            {name === 'Facebook' && <i className="fab fa-facebook-f"></i>}
            {name === 'Instagram' && <i className="fab fa-instagram"></i>}
            {name === 'YouTube' && <i className="fab fa-youtube"></i>}
            {name === 'TikTok' && <i className="fab fa-tiktok"></i>}
            {name === 'Doctoralia' && <i className="fas fa-user-md"></i>}
            {name === 'Guía Médica' && <i className="fas fa-book-medical"></i>}
          </span>
          {name}
        </h3>
        <p>@{username}</p>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="social-button"
        >
          Visitar {name}
        </a>
      </div>
    </div>
  );
};

export default SocialCard;
